(() => {
  const HERO_SELECTOR = '[data-drift-hero]';
  const VIDEO_SELECTOR = '[data-drift-hero-video]';


  const initHeroVideo = (hero) => {
    if (
      !hero ||
      hero.dataset.driftHeroVideoInitialized === 'true'
    ) {
      return;
    }


    const video =
      hero.querySelector(VIDEO_SELECTOR);

    if (!video) return;


    hero.dataset.driftHeroVideoInitialized = 'true';


    /*
      Keep the autoplay-safe properties on the DOM object too.
      This is especially helpful for Safari / iOS.
    */
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;

    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');


    const requestPlay = () => {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;

      const promise =
        video.play();

      if (
        promise &&
        typeof promise.catch === 'function'
      ) {
        promise.catch(() => {});
      }
    };


    /*
      Native `loop` should normally handle this.
      Keep an ended fallback in case a browser/theme script interferes.
    */
    const handleEnded = () => {
      try {
        video.currentTime = 0;
      } catch (_) {}

      requestPlay();
    };


    /*
      Safari can suspend background video when the tab is hidden or
      during page restoration. Resume it when the page becomes active.
    */
    const handleVisibilityChange = () => {
      if (
        !document.hidden &&
        video.paused
      ) {
        requestPlay();
      }
    };


    const handlePageShow = () => {
      if (video.paused) {
        requestPlay();
      }
    };


    const handleCanPlay = () => {
      if (video.paused) {
        requestPlay();
      }
    };


    video.addEventListener(
      'ended',
      handleEnded
    );

    video.addEventListener(
      'canplay',
      handleCanPlay
    );

    document.addEventListener(
      'visibilitychange',
      handleVisibilityChange
    );

    window.addEventListener(
      'pageshow',
      handlePageShow
    );


    requestPlay();


    hero.__driftHeroVideoCleanup = () => {
      video.removeEventListener(
        'ended',
        handleEnded
      );

      video.removeEventListener(
        'canplay',
        handleCanPlay
      );

      document.removeEventListener(
        'visibilitychange',
        handleVisibilityChange
      );

      window.removeEventListener(
        'pageshow',
        handlePageShow
      );

      delete hero.dataset.driftHeroVideoInitialized;
    };
  };


  const initAll = (root = document) => {
    if (
      root.matches?.(HERO_SELECTOR)
    ) {
      initHeroVideo(root);
    }

    root
      .querySelectorAll?.(HERO_SELECTOR)
      .forEach(
        initHeroVideo
      );
  };


  const cleanupRoot = (root) => {
    const heroes = [];


    if (
      root.matches?.(HERO_SELECTOR)
    ) {
      heroes.push(root);
    }


    root
      .querySelectorAll?.(HERO_SELECTOR)
      .forEach(
        (hero) => heroes.push(hero)
      );


    heroes.forEach(
      (hero) => {
        hero.__driftHeroVideoCleanup?.();
      }
    );
  };


  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => initAll(),
      { once: true }
    );
  } else {
    initAll();
  }


  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAll(event.target);
    }
  );


  document.addEventListener(
    'shopify:section:select',
    (event) => {
      initAll(event.target);
    }
  );


  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      cleanupRoot(event.target);
    }
  );
})();
